import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from '../translations/es';
import moment from 'moment'

Vue.use(VueI18n);

const messages = {
    es: es
};

const i18n = new VueI18n({
    locale: 'es',
    messages
});


moment.locale('es');


export default i18n;
